import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 1,
      name: i18n.t('tipos.rol_agenda.seller')
      // name: 'SellerParty'
    },
    {
      id: 2,
      name: i18n.t('tipos.rol_agenda.buyer')
      // name: 'BuyerParty'
    },
    {
      id: 3,
      name: i18n.t('tipos.rol_agenda.third')
      // name: 'ThirdParty'
    },
    {
      id: 4,
      name: i18n.t('tipos.rol_agenda.assignee')
      // name: 'Assignee'
    },
  ]
}

export function TIPOS_ROL_AGENDA (state) {
  return configHelper.getConfig(state, 'TIPOS_ROL_AGENDA', GenerateConfig)
}
